﻿import $ from 'jquery';
import { debounce } from './utils';
import WorkplaceService from "./WorkplaceService";

export default class EmploymentWorkplaceSelector extends HTMLInputElement {

    constructor() {
        super();
    }

    connectedCallback() {

        const input = $(this);

        input.typeahead({
            items: 'all',
            autoautoSelect: false,
            afterSelect: item => this.afterSelected(item),
            showHintOnFocus: true,
            minLength: 2,
            fitToElement: true,
            displayText: item => item.ListName,
            source: debounce(this.getWorkplaces, 200, this),
            matcher: this.matched
        });

        input.on("input", () => {
            this.workplaceId = "0";
        });

        this.initA11y();

    }

    afterSelected(item){
        if(item.CompanyNo === "-"){
            this.workplaceId = "0";
            this.value = item.CompanyName;    
        }
        else{
            this.workplaceId = item.CompanyNo;
        }
    }

    matched(item) {
        var it = this.displayText(item);

        if (item.CompanyNo === "-") {
            return true;
        }

        return ~it.toLowerCase().indexOf(this.query.toLowerCase());
    }

    initA11y() {
        this.setAttribute("role", "combobox");
        this.setAttribute("aria-haspopup", "listbox");
        this.setAttribute("aria-autocomplete", "list");
        this.setAttribute("aria-expanded", "false");

        $(this).closest(".form-group").on("show.bs.typeahead", ".dropdown-menu", e => {
            this.setAttribute("aria-expanded", "true");
        });

        $(this).closest(".form-group").on("hide.bs.typeahead", ".dropdown-menu", e => {
            this.setAttribute("aria-expanded", "false");
        });
    }

    getWorkplaces(query, process) {
        const workplaceService = new WorkplaceService();
        let city;


        if(this.selectedCity){
            city = this.selectedCity;
        }
        else{
            city = "-";
        }

        return workplaceService.getWorkplaces(city, query).done(data => {
            return process(data);
        });
        
    }

    disconnectedCallback() {

        $(this).typeahead("destroy");

    }

    get selectedCity() {
        return document.querySelector(`#${this.getAttribute("data-employmentcity-selector")}`).value;
    }

    set workplaceId(value) {
        return document.querySelector(`#${this.getAttribute("data-workplaceid-field")}`).value = value;
    }
}

customElements.define("employment-workplace", EmploymentWorkplaceSelector, { extends: "input" });